import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { REPORT } from "../config/apiEndPoint";
import { GET, POST } from "config/api.config";

const unwrapOptionsList = (payload) => {
    const data = payload?.data ?? payload;
    if (Array.isArray(data)) return data;
    const inner = data?.records ?? data?.rows ?? data?.items ?? data?.data;
    return Array.isArray(inner) ? inner : [];
};

export const mapClientReportOptionsToSelect = (payload) =>
    unwrapOptionsList(payload)
        .map((item) => {
            if (typeof item === "string") {
                const value = item.trim();
                return value ? { value, label: value } : null;
            }

            const value = String(
                item?.value ??
                    item?.id ??
                    item?._id ??
                    item?.clientId ??
                    item?.key ??
                    item?.code ??
                    item?.name ??
                    ""
            ).trim();
            const label = String(
                item?.label ??
                    item?.display ??
                    item?.clientName ??
                    item?.client ??
                    item?.name ??
                    item?.title ??
                    value
            ).trim();

            return value ? { value, label: label || value } : null;
        })
        .filter(Boolean);

/** GET `Report/client/options/report-type` */
export const fetchClientReportReportTypeOptions = async () => {
    try {
        const response = await GET(REPORT.CLIENT_OPTIONS_REPORT_TYPE);
        return mapClientReportOptionsToSelect(response);
    } catch (error) {
        toast.error(error?.message);
        return [];
    }
};

/** GET `Report/client/options/clients` */
export const fetchClientReportClientOptions = async () => {
    try {
        const response = await GET(REPORT.CLIENT_OPTIONS_CLIENTS);
        return mapClientReportOptionsToSelect(response);
    } catch (error) {
        toast.error(error?.message);
        return [];
    }
};

/** GET `Report/client/options/submit-action` */
export const fetchClientReportSubmitActionOptions = async () => {
    try {
        const response = await GET(REPORT.CLIENT_OPTIONS_SUBMIT_ACTION);
        return mapClientReportOptionsToSelect(response);
    } catch (error) {
        toast.error(error?.message);
        return [];
    }
};

/** POST `Report/client/filter` */
export const submitClientReportFilterData = async (data = {}) => {
    try {
        const response = await POST(REPORT.CLIENT_FILTER, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

/** POST `Report/client/send` */
export const submitClientReportSendData = async (data = {}) => {
    try {
        const response = await POST(REPORT.CLIENT_SEND, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};
